import { portalAccess } from './PortalAccess';

export const canViewDirectories = (user) =>
  portalAccess(user).dispatcher;
